import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Button,
  Drawer,
  IconButton,
  Toolbar,
  LinearProgress,
  Fade
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { toggleCart } from "../../actions";
import logo from "../../images/Logo.svg";
import { isMobile } from "../../userAgentDetect";
import styles from "./styles";

let NavBarItems = ({ className, classes, generating, updating, openCart }) => (
  <div className={className}>
    <Link to="/Products" className={classNames(classes.item, classes.hover)}>
      Products
    </Link>
    <Link to="/About" className={classNames(classes.item, classes.hover)}>
      About us
    </Link>
    <Link to="/Faq" className={classNames(classes.item, classes.hover)}>
      FAQ
    </Link>
    <button
      className={classNames(classes.item, classes.hover)}
      onClick={openCart}
    >
      Cart
    </button>
    <Button
      variant="outlined"
      className={classNames(classes.item, classes.btnItem)}
      component={Link}
      size="large"
      to="/create/mosaic"
      disabled={generating || updating}
    >
      {generating ? "generating" : updating ? "updating" : "Create"}
    </Button>
  </div>
);
const mapStateToNavBarItemsProps = state => ({
  generating: state.mosaic.generating,
  updating: state.mosaic.updatingAlpha
});
NavBarItems = connect(
  mapStateToNavBarItemsProps,
  { openCart: () => toggleCart(true) }
)(NavBarItems);

const DrawerItems = ({ classes, ...props }) => (
  <div {...props}>
    <Link to="/Products" className={classNames(classes.item, classes.linkItem)}>
      Products
    </Link>
    <Link to="/About" className={classNames(classes.item, classes.linkItem)}>
      About us
    </Link>
    <Link to="/Faq" className={classNames(classes.item, classes.linkItem)}>
      FAQ
    </Link>
    <hr className="divider" />
    <p className={classes.contact}>
      <svg
        className={classes.icon}
        aria-hidden="true"
        data-prefix="fas"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          fill="currentColor"
          d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
        />
      </svg>
      Contact us at
    </p>
    <a className="link" href="mailto:support@mondaybee.com" target="_top">
      support@mondaybee.com
    </a>
  </div>
);

class TitleBar extends Component {
  state = {
    open: false
  };
  toggleDrawer = bool => () => {
    this.setState({ open: bool });
  };
  render() {
    const { classes, progress, progressError, zenMode } = this.props;
    return (
      <AppBar position="fixed" color="default" className={classes.root}>
        <Toolbar
          classes={{
            root: classes.toolbar,
            gutters: classes.gutters,
            regular: classes.regular
          }}
        >
          <Link
            variant="title"
            color="inherit"
            className={classes.title}
            to="/"
          >
            <img src={logo} alt="Mondaybee Logo" className={classes.logo} />
            <h1>Mondaybee</h1>
          </Link>
          {!isMobile && !zenMode && (
            <NavBarItems
              className={classes.navItemsContainer}
              classes={classes}
            />
          )}
          {isMobile && (
            <Fragment>
              <IconButton
                className={classes.menuButton}
                color="inherit"
                aria-label="Menu"
                onClick={this.toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                classes={{ paper: classes.drawer }}
                open={this.state.open}
                onClose={this.toggleDrawer(false)}
              >
                <DrawerItems
                  classes={classes}
                  className={classes.drawerItemsContainer}
                  tabIndex={0}
                  role="button"
                  onClick={this.toggleDrawer(false)}
                  onKeyDown={this.toggleDrawer(false)}
                />
              </Drawer>
            </Fragment>
          )}
        </Toolbar>
        <Fade
          in={!!progress && progress !== 100}
          timeout={{ enter: 0, exit: 3000 }}
        >
          <div className={classes.progressContainer}>
            <LinearProgress
              classes={{
                colorPrimary: classes.progressColorPrimary,
                colorSecondary: classes.progressColorPrimary
              }}
              color={progressError ? "secondary" : "primary"}
              variant="determinate"
              value={progress ? progress : 0}
            />
          </div>
        </Fade>
      </AppBar>
    );
  }
}

TitleBar.propTypes = {
  classes: PropTypes.object.isRequired,
  zenMode: PropTypes.bool.isRequired,
  progress: PropTypes.number,
  progressError: PropTypes.bool
};

const mapStateToProps = ({
  router: {
    location: { pathname }
  },
  mosaic
}) => ({
  zenMode: pathname === "/checkout",
  progress: mosaic.progress,
  progressError: mosaic.error
});

export default withStyles(styles)(connect(mapStateToProps)(TitleBar));



// WEBPACK FOOTER //
// ./src/components/TitleBar/index.js